__turbopack_context__.v({
  "social-logins-form": "social-logins-module-scss-module__NNK2Ra__social-logins-form",
  "social-logins-form__content": "social-logins-module-scss-module__NNK2Ra__social-logins-form__content",
  "social-logins-form__content--reduce-spacing": "social-logins-module-scss-module__NNK2Ra__social-logins-form__content--reduce-spacing",
  "social-logins-form__fieldset": "social-logins-module-scss-module__NNK2Ra__social-logins-form__fieldset",
  "social-logins-form__footer": "social-logins-module-scss-module__NNK2Ra__social-logins-form__footer",
  "social-logins-form__heading": "social-logins-module-scss-module__NNK2Ra__social-logins-form__heading",
  "social-logins-form__legend": "social-logins-module-scss-module__NNK2Ra__social-logins-form__legend",
  "social-logins-form__separator": "social-logins-module-scss-module__NNK2Ra__social-logins-form__separator",
  "social-logins-form__sub-heading": "social-logins-module-scss-module__NNK2Ra__social-logins-form__sub-heading",
});
